var React = require('react');

function CrumbSeparator (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.80561 5L0.899712 1.61666C0.723191 1.46376 0.699341 1.19106 0.846442 1.00758L1.37914 0.343119C1.52624 0.159634 1.78859 0.134843 1.96511 0.287747L6.6381 4.33554C6.82781 4.49987 6.9375 4.74331 6.9375 5C6.9375 5.25669 6.82781 5.50013 6.6381 5.66446L1.96511 9.71225C1.78859 9.86516 1.52624 9.84037 1.37914 9.65688L0.846442 8.99242C0.699341 8.80894 0.723191 8.53624 0.899712 8.38334L4.80561 5Z","fill":"#6366F1"}));
}

CrumbSeparator.defaultProps = {"width":"7","height":"10","viewBox":"0 0 7 10","fill":"none"};

module.exports = CrumbSeparator;

CrumbSeparator.default = CrumbSeparator;
